import React, { useEffect, useState } from "react";
import { Modal, } from "reactstrap";
import { toast } from 'react-toastify';
import centerServices from "../../services/center.services";
import xrayBookingsServices from "../../services/xrayBookings.services";
import BookingList from "../../components/XrayInvesReport/XrayBookingsList";
import XrayBookingForm from "../../components/XrayInvesReport/AssignCardiologistForm";
import userServices from "../../services/user.services";
const XrayInveBooking = () => {
    const [modal, setModal] = React.useState(false);
    const toggle = () => setModal(!modal);
    const [centers, setCenters] = useState([]);
    const [selectedRow, setSelectedRow] = useState();
    const [isAddMode, setIsAddMode] = useState('Add');
    const [isCenter, setIsCenter] = useState(true);
    const [xrayBookings, setXrayBookings] = useState([]);
    const [doctors, setDoctors] = useState([])
    const [loading, setLoading] = useState(true);
    const getAllCenters = () => {
        centerServices.getAllCenter()
            .then((res) => {
                if (res.data.status === true) {
                    setCenters(res.data.centers)
                }
            }).catch((error) => {
                console.log('error', error)
            })
    }
    const getAllDoctors = () => {
        userServices.getAllUsers()
            .then((res) => {
                if (res.data.status === true) {
                    const rs = res.data.users.filter((item) => {
                        return item.user_type_id === 5;
                    })
                    setDoctors(rs)
                }
            }).catch((error) => {
                console.log('error', error)
            })
    }
    const getAllBookings = async () => {
        const bookings = await xrayBookingsServices.bookingListApi()
        if (bookings.status === 200) {
            setXrayBookings(bookings.data.booking_details)
        }
        setLoading(false);
    }
    useEffect(() => {
        getAllCenters();
        getAllBookings();
        getAllDoctors();
    }, [])

    const handleSelect = (key) => {
        if (key === "center-info") {
            setIsCenter(true)
        }
        else
            setIsCenter(false)
    }
    const pendingXrayInvestigationReports = xrayBookings.filter(item => item.inves_report_opted === true);

    return (
        <React.Fragment>
            {/*page-wrapper*/}
            <div className="page-wrapper">
                {/*page-content-wrapper*/}
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <>
                            {/*breadcrumb*/}
                            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                                {/* <div className="breadcrumb-title pe-3">Center</div> */}
                                <div className="ps-3">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb mb-0 p-0">
                                            <li className="breadcrumb-item">
                                                <a href="#">
                                                    {/* <i className="bx bx-home-alt" /> */}
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                X-ray Investigation Report
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div className="ms-auto">
                                    <div className="btn-group">
                                        <Modal isOpen={modal} toggle={toggle} size="lg">
                                            <XrayBookingForm toggle={toggle} getAllBookings={getAllBookings} isAddMode={isAddMode} selectedRow={selectedRow} doctors={doctors} />
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                            {/*end breadcrumb*/}
                            <div className="card">
                                <div className="card-body">
                                    <BookingList bookings={pendingXrayInvestigationReports} loading={loading} setIsAddMode={setIsAddMode} setSelectedRow={setSelectedRow} setModal={setModal} getAllCenters={getAllCenters} />
                                </div>
                            </div>

                        </>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default XrayInveBooking;